import React, { useState, useEffect } from 'react'
import { Alert, Typography } from '@mui/material';
import { Modal, Accordion } from 'react-bootstrap'
import UpdateForm from './UpdateForm'
import { readSessionUser } from '../accountAccess';

export default function LocationSetup() {

  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('')
  const [accessError, setAccessError] = useState('')

  //API call
  useEffect(() => {

    const { user: foundUser, error } = readSessionUser();

    if (error || !foundUser) {
      setAccessError(error || 'Your login session is unavailable. Please sign in again.');
      return;
    }

    if (foundUser.role_capabilities?.all_modules_access === true) {
      setAccessType('Edit');
      return;
    }

    const locationAccess = foundUser.access?.['Location_Access Specifier'];
    if (locationAccess !== 'Edit' && locationAccess !== 'View') {
      setAccessError('Your Location access details are unavailable. Please sign out and sign in again.');
      return;
    }
    setAccessType(locationAccess);
  }, []);


  return (
    <>

      <div className="row">

        <div className="row my-3 ">
          <div className="col-md-6">
            <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
              Location {accessType === 'View' && "/ View Only Mode"}
            </Typography>
          </div>

          <div className="col-md-6 d-flex justify-content-end">
            <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
            <Modal
              size="lg"
              show={lgShow}
              onHide={() => setLgShow(false)}
              aria-labelledby="example-modal-sizes-title-lg"

            >
              <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                <Modal.Title id="example-modal-sizes-title-lg" >
                  Instructions to Add/Edit Location Information
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ backgroundColor: '#F8FAFC', padding: '24px' }}>
                <style>{`
                  .help-badge {
                    padding: 4px 10px;
                    border-radius: 16px;
                    font-weight: 700;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-right: 10px;
                  }
                  .badge-create { background: #e6fffa; color: #234e52; border: 1px solid #b2f5ea; }
                  .badge-update { background: #fffaf0; color: #9c4221; border: 1px solid #feebc8; }
                  
                  .help-card-text {
                    font-size: 14px;
                    color: #4a5568;
                    line-height: 1.5;
                    margin-bottom: 16px;
                  }
                  .video-responsive-wrapper {
                    position: relative;
                    width: 100%;
                    padding-top: 56.25%; /* 16:9 Aspect Ratio */
                    border-radius: 8px;
                    overflow: hidden;
                    background: #000000;
                  }
                  .video-responsive-wrapper video {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                  .accordion-button:not(.collapsed) {
                    background-color: #f1f5f9;
                    color: #1e293b;
                  }
                `}</style>

                <Accordion defaultActiveKey="0" flush>

                  {/* 1. CREATE LOCATION SETUP */}
                  <Accordion.Item eventKey="0" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-create">Create</span>
                      <strong>How to Create Location Setup</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Select the <strong>Account Name</strong> and <strong>Location Name</strong> from the respective dropdowns. Enter or update the required details and click the <strong>Update</strong> button. A confirmation pop-up will be displayed stating, <em>"Location Setup successful!"</em>
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Location - create.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 2. UPDATE LOCATION SETUP */}
                  <Accordion.Item eventKey="1" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-update">Update</span>
                      <strong>How to Update Location Setup</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Select the <strong>Account Name</strong> and <strong>Location Name</strong> from the respective dropdowns. Enter or update the required details and click the <strong>Update</strong> button. A confirmation pop-up will be displayed stating, <em>"Location Setup successful!"</em>
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Location - edit.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                </Accordion>
              </Modal.Body>
            </Modal>
          </div>
        </div>

      </div>

      {accessError ? (
        <div className="mx-3">
          <Alert severity="error">{accessError}</Alert>
        </div>
      ) : (
        <UpdateForm accessType={accessType} />
      )}
    </>
  );
}
